import { queryRoots, type QueryKey } from '@/shared/query';

export type ScheduleListQueryParams = {
  agentId?: string;
  includeCancelled?: boolean;
  limit: number;
  offset: number;
};

export const scheduleKeys = {
  all: (): QueryKey => [queryRoots.schedules],
  list: (params: ScheduleListQueryParams): QueryKey => [
    queryRoots.schedules,
    'list',
    params.agentId ?? null,
    params.includeCancelled ?? false,
    params.limit,
    params.offset,
  ],
} as const;
